import React from 'react'
import WhyChooseUs from '../../components/User/About/WhyChooseUs'
import AboutUs from '../../components/User/About/AboutUs'
import Testimonials from '../../components/User/About/Testimonials'
import SimpleBanner from '../../components/common/SimpleBanner'
import FaqSection from '../../components/User/About/Faqsection'

const About = () => {
  return (
    <div>
      <SimpleBanner   title = "About Us" subheading = "Home /About Us"/>
      <WhyChooseUs/>
      <AboutUs/>
      <Testimonials/>
      <FaqSection/>
    </div>
  )
}

export default About
